import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

import { apiResourceEndpoint, routes } from '../../../constants/routes'
import { fetchApiDataIfNeeded } from '../../../actions/api'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const mapStateToProps = (state) => {
    return {
        primaryAreas: state.chefServiceAreas.filter(area => area.chefId === state.user?.apiUserId && area.availabilityType === 'PRIMARY'),
        temporaryAreas: state.chefServiceAreas.filter(area => area.chefId === state.user?.apiUserId && area.availabilityType === 'TEMPORARY'),
        menus: state.chefMenus.filter(m => m.chefId === state.user?.apiUserId),
        photos: state.chefPhotos.filter(p => p.chefId === state.user?.apiUserId),
        profilePhoto: state.chefPhotos.find(cp => cp.isProfile === true)
    }
}

const ChefPortalOverview = ({ dispatch, chef, primaryAreas, temporaryAreas, handleDelete, menus, photos, profilePhoto }) => {
    useEffect(() => {
        dispatch(fetchApiDataIfNeeded(apiResourceEndpoint('chefs/chef-service-areas', 'LIST')))
        dispatch(fetchApiDataIfNeeded(apiResourceEndpoint('chefs/chef-menus', 'LIST')))
        dispatch(fetchApiDataIfNeeded(apiResourceEndpoint('chefs/chef-photos', 'LIST')))
    }, [dispatch])

    const renderChefProfileRequirement = () => {
        return (
            <Link to={routes.chefPortalProfile.path} className="overview-task" style={{ textDecoration: 'none', color: 'inherit' }}>
                <div className="icon-wrapper">
                    <FontAwesomeIcon icon="user-ninja" />
                </div>
                <div className="label-wrapper">
                    <h4>Profile</h4>
                </div>
                <div className="button-wrapper">
                    {
                        chef.shortBio && profilePhoto ? (
                            <span className="complete"><FontAwesomeIcon icon="circle-check" /></span>
                        ) : (
                            <span className="action-btn">Continue</span>
                        )}
                </div>
            </Link>
        )
    }

    // const renderChefDocumentsRequirement = () => {
    //     return (
    //         <div className="overview-task">
    //             <div className="icon-wrapper">
    //                 <FontAwesomeIcon icon="file-alt" />
    //             </div>
    //             <div className="label-wrapper">
    //                 <h4>
    //                     <Link to={routes.chefPortalDocuments.path}>Documents</Link>
    //                 </h4>
    //             </div>
    //             <div className="button-wrapper">
    //                 {
    //                     chef.shortBio && chef.profilePhoto
    //                         ? <span className="complete">complete <FontAwesomeIcon icon="circle-check" /></span>
    //                         : <Link className="action-btn" to={routes.chefPortalDocuments.path}>Continue</Link>
    //                 }
    //             </div>
    //         </div>
    //     )
    // }

    const renderChefPhotosOption = () => {
        return (
            <Link to={routes.chefPortalPhotos.path} className="overview-task" style={{ textDecoration: 'none', color: 'inherit' }}>
                <div className="icon-wrapper">
                    <FontAwesomeIcon icon="images" />
                </div>
                <div className="label-wrapper">
                    <h4>
                        Photos
                    </h4>
                </div>
                <div className="button-wrapper">
                    {photos.length > 0 ? (
                        <span className="complete"><FontAwesomeIcon icon="circle-check" /></span>
                    ) : (
                        <span className="action-btn">Continue</span>
                    )}
                </div>
            </Link>
        )
    }

    const renderChefMenusOption = () => {
        return (
            <Link to={routes.chefPortalMenusIndex.path} className="overview-task" style={{ textDecoration: 'none', color: 'inherit' }}>
                <div className="icon-label-wrapper">
                    <div className="icon-wrapper">
                        <FontAwesomeIcon icon="bowl-rice" />
                    </div>
                    <div className="label-wrapper">
                        <h4>
                            Menus
                        </h4>
                    </div>
                </div>
                <div className="button-wrapper">
                    {menus.length > 0 ? (
                        <span className="complete"><FontAwesomeIcon icon="circle-check" /></span>
                    ) : (
                        <span className="action-btn">Continue</span>
                    )}
                </div>
            </Link>
        )
    }

    const renderChefAvailabilityOption = () => {
        return (
            <Link to={routes.chefPortalAvailability.path} className="overview-task" style={{ textDecoration: 'none', color: 'inherit' }}>
                <div className="icon-label-wrapper">
                    <div className="icon-wrapper">
                        <FontAwesomeIcon icon={['far', 'calendar-alt']} />
                    </div>
                    <div className="label-wrapper">
                        <h4>
                            Availability
                        </h4>
                    </div>
                </div>
                <div className="button-wrapper">
                    {primaryAreas.length > 0 ? (
                        <span className="complete"><FontAwesomeIcon icon="circle-check" /></span>
                    ) : (
                        <span className="action-btn">Continue</span>
                    )}
                </div>
            </Link>
        )
    }

    return (
        <>
            <div className="chef-block header" style={{ background: 'url(/img/bg/gold-table-cloth-bg.jpg)', backgroundSize: 'no-cover', backgroundRepeat: 'no-repeat' }}>
                {chef.shortBio && profilePhoto ? (
                    <>
                        <h2>welcome back</h2>
                        <p>Please continue to update and customize your profile below.</p>

                    </>
                ) : (
                    <>
                        <h2>welcome to tivity</h2>
                        <p>Here you can set up your profile, upload photos, create menus and upload documents to get started working with us!</p>
                    </>
                )}
            </div>
            <h3>Required</h3>
            { !chef.shortBio ? (
                <div className="chef-block required">
                    <div className="content required">
                        <FontAwesomeIcon icon="hand-sparkles" />
                        <p>Complete all required sections below to begin working with tivity</p>
                    </div>
                </div>
            ) : null
            }
            {renderChefProfileRequirement()}
            {/* {renderChefDocumentsRequirement()} */}

            <h3>Recommended</h3>
            { !profilePhoto ? (
                <div className="chef-block required">
                    <div className="content required">
                        <FontAwesomeIcon icon="hand-sparkles" />
                        <p>Make your profile stand out by adding additional photos and menus.</p>
                    </div>
                </div>
            ) : null
            }
            {renderChefPhotosOption()}
            {renderChefMenusOption()}
            {renderChefAvailabilityOption()}
        </>
    )
}

export default connect(mapStateToProps)(ChefPortalOverview)
